import { queryOptions } from '@tanstack/react-query'
import { api } from '../lib/api'

export const masterTypeQueryOptions = (enabled?: boolean, page?: number, pageSize?: number) =>
    queryOptions({
        queryKey: ['master-type', page, pageSize],
        queryFn: () => api.masterType.list({ page: page ?? 1, take: pageSize ?? 100 }),
        staleTime: 1000 * 60 * 5,
        enabled: enabled ?? true,
    })

export const regionQueryOptions = (enabled?: boolean, page?: number, pageSize?: number) =>
    queryOptions({
        queryKey: ['masterdata-regions', page, pageSize],
        queryFn: () => api.region.list({ page: page ?? 1, take: pageSize ?? 100 }),
        staleTime: 1000 * 60 * 5,
        enabled: enabled ?? true,
    })

export const areaQueryOptions = (enabled?: boolean, regionIds?: string, page?: number, pageSize?: number) =>
    queryOptions({
        queryKey: ['masterdata-areas', regionIds, page, pageSize],
        queryFn: () => api.area.list({ page: page ?? 1, take: pageSize ?? 100, regionIds }),
        staleTime: 1000 * 60 * 5,
        enabled: enabled ?? true,
    })

export const departmentQueryOptions = (enabled?: boolean, page?: number, pageSize?: number) =>
    queryOptions({
        queryKey: ['masterdata-departments', page, pageSize],
        queryFn: () => api.department.list({ page: page ?? 1, take: pageSize ?? 100 }),
        staleTime: 1000 * 60 * 5,
        enabled: enabled ?? true,
    })
